// Copyright (c) 2020-2023 Omics Data Automation, Inc.
// Copyright (c) 2023 datma, inc.
//
// Proprietary and Confidential:
// Unauthorized copying of this file by any medium is strictly prohibited.

import { store } from '@/store'
import { fetchWithTimeout } from '@/common/shared'
import { tumorBoardBaseUrl } from '@/settings'

export const getRequestingPhysicians = async () => {
  try {
    const fetchParams = {
      method: 'GET',
      headers: {
        'Authorization': 'Bearer ' + store.getters.jwt,
      },
    }
    const url = `${tumorBoardBaseUrl}/api/v1/tb_caregivers`
    const response = await fetchWithTimeout(url, fetchParams)
    if (!response.ok) {
      console.log(`error: status=${response.status}`)
      return []
    }
    const result = await response.json()

    // Sort by name
    result[0].caregivers.sort((a, b) => a.name.toUpperCase() > b.name.toUpperCase() ? 1 : -1)

    if (!result || !result[0] || result[0].caregivers.length === 0) { return [] }
    // Translate the response to the format expected by the frontend.
    return result[0].caregivers
  } catch (e) {
    if (e.name === 'AbortError') {
      console.log('timeout error')
    } else {
      console.log('ERROR:', e)
    }
  }
  return []
}
